import { useMemo } from 'react';

import { useUserDateTimePreferences } from '@sbu/hooks.time';

import { formatDateFactory } from 'shared/utils';

export const useFormatDate = () => {
  const { dateFormat } = useUserDateTimePreferences();

  return useMemo(() => formatDateFactory(dateFormat), [dateFormat]);
};

export type FormatDate = ReturnType<typeof useFormatDate>;
